export const PricingRequest = ({
  clientCode,
  userID,
  key,
  agencyId,
  flight,
  Journey,
  ClassOfService,
  flightsListRequest
}) => {

  const fareQuoteRequests = [];

  // Case 1: Round-trip (onward + return)
  if (flight?.onward || flight?.return) {

    if (flight?.onward) {
      fareQuoteRequests.push(
        mapFlightToAirPricing(
          flight.onward,
          flightsListRequest,
          agencyId,
          ClassOfService,
          "Onward"
        )
      );
    }

    if (flight?.return) {
      fareQuoteRequests.push(
        mapFlightToAirPricing(
          flight.return,
          flightsListRequest,
          agencyId,
          ClassOfService,
          "Return"
        )
      );
    }

  }
  // Case 2: One-way (single flight object)
  else {
    fareQuoteRequests.push(
      mapFlightToAirPricing(
        flight,
        flightsListRequest,
        agencyId,
        ClassOfService,
        "Onward"
      )
    );
  }

  return {
    clientCode,
    userID,
    key,
    resultIndex: flight?.resultIndex || "",
    fareQuoteRequests
  };
};


const mapFlightToAirPricing = (
  flight,
  flightsListRequest,
  agencyId,
  ClassOfService,
  Journey
) => ({
  sCode: flight?.sCode || "",
  supSource: flight?.supSource || "",
 resultIndex: flight?.itemNo || "",
  fareUniqueKey: flight?.fares?.[0]?.fareUniqueKey || "",
  journey: Journey
});

// export const PricingRequest = ({
//   clientCode,
//   userID,
//   key,
//   agencyId,
//   flight,
//   Journey, ClassOfService,
//   flightsListRequest
// }) => {

// debugger;
//   return {
//     clientCode,
//     userID,
//     key,
//     //sessionID: referenceNo,
//     resultIndex: flight?.resultIndex || "",
//     airPricingRequest: [
//       {
//         sCode: flight?.sCode || "",
//         supSource: flight?.supSource || "",
//         //journey: flight?.journey || "",
//         trip: flight?.trip || 1,
//         tripType: flight?.tripType || 1,
//         planType: flight?.planType || "",
//         origin: flight?.origin || "",
//         destination: flight?.destination || "",
//         departDate: flightsListRequest.departDate || "",
//         returnDate: flightsListRequest?.returnDate || "",
//         adult: flight?.adult || 1,
//         child: flight?.child || 0,
//         infant: flight?.infant || 0,
//         validatingCarrier: flight?.validatingCarrier || "",
//         flightKey: flight?.flightKey || "",
//         //fareKey: flight?.fa || "TEMP-FAREKEY",
//         fareKey: flight.fares[0].fareUniqueKey,

//         flightDetails: flight.segments || [],

//         paxFareRules: flight?.paxFareRules || [],
//         fareDetails: flight?.fareDetails || {},
//         tokenId: flight?.tokenId || "",
//         traceId: flight?.traceId || "",
//         sIndex: flight?.sIndex || "",
//         isLCC: flight?.isLCC || false,

//         baggageDetails: flight?.baggageDetails || [],
//         //baggageDetails: flight?.bagInfo || [],
        
//         mealDetails: flight?.mealDetails || [],
//         totalDuration: flight?.totalDuration || "",
//         totalDurationReturn: flight?.totalDurationReturn || "",
//         connectionSegmentIndex: flight?.connectionSegmentIndex || "",
//         bagInfo: flight?.bagInfo || "",
//         isRefundable: flight?.isRefundable || false,
//         productClass: flight?.productClass || "",
//         airlineRemark: flight?.airlineRemark || "",
//         isGSTMandatory: flight?.isGSTMandatory || false,
//         isBookingHold: flight?.isBookingHold || false,
//         holdMessage: flight?.holdMessage || "",
//         bookingHoldOn: flight?.bookingHoldOn || null,
//         isPriceChange: flight?.isPriceChange || false,
//         paxOtherDetails: flight?.paxOtherDetails || [],
//         error: flight?.error || null,
//         status: flight?.status || "",
//         agencyId: agencyId || "",
//         fareType: flight?.fareType || "",
//         idType: flight?.idType || "",
//         lastTicketDate: flight?.lastTicketDate || "",
//         preferredClass: ClassOfService,
//         journey:Journey
//       },
//     ],
//   };
// };